import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
  };
  return (
    <Shell title="Reset your password">
      {sent ? (
        <p className="text-sm text-npst-inkSoft" data-testid="forgot-confirm">If that email is registered, a reset link has been sent. Please check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><label className="label-eyebrow text-npst-muted block mb-2">Email</label><Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" /></div>
          <Button type="submit" data-testid="forgot-submit" className="w-full h-12 bg-npst-navy text-white">Send reset link</Button>
        </form>
      )}
      <div className="mt-4 text-center"><Link to="/admin/login" className="text-sm text-npst-muted hover:text-npst-navy">← Back to sign in</Link></div>
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      navigate("/admin/login");
    } catch (err) { setError(apiError(err.response?.data?.detail)); }
  };
  return (
    <Shell title="Choose a new password">
      {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}
      <form onSubmit={submit} className="space-y-4">
        <div><label className="label-eyebrow text-npst-muted block mb-2">New Password</label><Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" /></div>
        <Button type="submit" data-testid="reset-submit" className="w-full h-12 bg-npst-navy text-white">Reset password</Button>
      </form>
      <div className="mt-4 text-center"><Link to="/admin/login" className="text-sm text-npst-muted hover:text-npst-navy">← Back to sign in</Link></div>
    </Shell>
  );
}

function Shell({ title, children }) {
  return (
    <div className="min-h-screen bg-npst-navyDeep flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-lg p-8 shadow-2xl">
        <div className="label-eyebrow text-npst-gold mb-2">Administrative Portal</div>
        <h1 className="font-serif text-3xl text-npst-ink mb-6">{title}</h1>
        {children}
      </div>
    </div>
  );
}
